import {AnalyticsEventMetadata} from 'analytics/AnalyticsTypes';
import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {TestOrderStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import {HTTPHeaders, patchJSONPromise, postJSONPromise} from 'util/Net';

export interface TestOrderLinkedPlateWell {
  plateId: string;
  wellPosition: string;
}

export interface CreateTestOrderParams {
  testDefinitionId: string;
  sampleId: string;
  containerId: string | null;
  dilutionFactor: number | null;
  studyIds: Array<string>;
  procedureId: string;
}

export interface CreateTestOrderResponse {
  createdIds: Array<string>;
}

export function createTestOrder(testOrder: CreateTestOrderParams): Promise<CreateTestOrderResponse> {
  const creates = [testOrder];
  return postJSONPromise({url: getApiBaseForObjectType(DomainGraphType.TEST_ORDER), data: {creates}});
}

export function createTestOrders(
  testOrders: Array<CreateTestOrderParams>,
  analyticsMetadata?: AnalyticsEventMetadata
): Promise<CreateTestOrderResponse> {
  return postJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.TEST_ORDER),
    data: {creates: testOrders},
    analyticsMetadata,
  });
}

export interface UpdateTestOrderResponse {
  updatedIds: Array<string>;
}

export function bulkUpdateTestOrders(
  testOrderIds: Array<string>,
  {status, containerId}: {status?: TestOrderStatus; containerId?: string},
  analyticsMetadata?: AnalyticsEventMetadata,
  extraHeaders?: HTTPHeaders
): Promise<UpdateTestOrderResponse> {
  return patchJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.TEST_ORDER),
    data: {updates: testOrderIds.map((id) => ({id, status, containerId}))},
    analyticsMetadata,
    extraHeaders,
  });
}

export function workaroundProgressTestOrdersOnPlatesForMethodInstance(
  plateIds: Array<string>,
  pmeiId: string
): Promise<void> {
  return postJSONPromise({
    url: '/1/api/progress-test-orders-on-plates',
    data: {plateIds, pmeiId},
  });
}
